import { Col, Form, Input, Row } from 'antd';
import MaskedInput from 'antd-mask-input';
import PropTypes from 'prop-types';
import React from 'react';

import SubHeader from '../../../../../components/SubHeader';
import { isCpfValid } from '../../../../../helpers/validators';

export default function FormDadosPessoais({ isEditing }) {
  const renderColInputName = () => (
    <Col xs={12} lg={12} xl={12}>
      <Form.Item
        name="name"
        rules={[
          { required: isEditing, message: 'Por favor, digite seu nome!' },
        ]}
        label="Nome"
        labelAlign="right"
        labelCol={{ xl: { span: 5 }, lg: { span: 6 } }}
      >
        <Input className="total-width" disabled={!isEditing} />
      </Form.Item>
    </Col>
  );

  const renderColInputEmail = () => (
    <Col xs={12} lg={12} xl={12}>
      <Form.Item
        name="email"
        rules={[
          {
            required: isEditing,
            message: 'Por favor, digite seu e-mail!',
          },
        ]}
        label="E-mail"
        labelAlign="right"
        labelCol={{ xl: { span: 5 }, lg: { span: 6 } }}
      >
        <Input type="email" className="total-width" disabled />
      </Form.Item>
    </Col>
  );

  const checkIfCpfIsValid = async value => {
    if (!isCpfValid(value)) {
      return Promise.reject();
    }

    return Promise.resolve();
  };

  const renderColInputCPF = () => (
    <Col xs={12} lg={12} xl={12}>
      <Form.Item
        name="cpf"
        rules={[
          {
            required: isEditing,
            message: 'Por favor, digite seu CPF!',
          },
          {
            message: 'Por favor, digite um CPF válido',
            validator: (_, value) => checkIfCpfIsValid(value),
          },
        ]}
        label="CPF"
        labelAlign="right"
        labelCol={{ xl: { span: 5 }, lg: { span: 6 } }}
      >
        <MaskedInput
          className="total-width"
          mask="111.111.111-11"
          disabled={!isEditing}
          onBlur={checkIfCpfIsValid}
        />
      </Form.Item>
    </Col>
  );

  const renderColInputPhoneNumber = () => (
    <Col xs={12} lg={12} xl={12}>
      <Form.Item
        name="phone_number"
        rules={[
          {
            required: isEditing,
            message: 'Por favor, digite seu telefone!',
          },
        ]}
        label="Telefone"
        labelAlign="right"
        labelCol={{ xl: { span: 5 }, lg: { span: 6 } }}
      >
        <MaskedInput
          className="total-width"
          mask="(11) 1 1111-1111"
          disabled={!isEditing}
        />
      </Form.Item>
    </Col>
  );

  return (
    <>
      <SubHeader title="Dados pessoais" />

      <Row gutter={12}>
        {renderColInputName()}
        {renderColInputEmail()}
        {renderColInputCPF()}
        {renderColInputPhoneNumber()}
      </Row>
    </>
  );
}

FormDadosPessoais.propTypes = {
  isEditing: PropTypes.bool,
};

FormDadosPessoais.defaultProps = {
  isEditing: false,
};
